import { css } from 'styled-components';
import { device, sizes } from '../components/variables/variables';
import { colors } from '../constants/colors';
import type { IColors } from '../constants/colors';

export const Container = () => css`
  width: 100%;
  padding-left: ${sizes.paddingContainer};
  padding-right: ${sizes.paddingContainer};
  @media ${device.mobile} {
    padding-left: ${sizes.paddingContainerMobile};
    padding-right: ${sizes.paddingContainerMobile};
  }
`;

export const ButtonGreen = () => css`
  width: 100%;
  height: 6.4rem;
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: 6.4rem;
  background: ${colors.green};
  text-transform: uppercase;
  font-weight: 500;
  padding: 0 2.4rem;
  white-space: nowrap;
  font-size: 1.8rem;
  line-height: 140%;
  display: flex;
  align-items: center;
  text-align: center;
  color: ${colors.darkBlue};
  transition: 0.3s background-color ease-in-out, 0.3s color ease-in-out;
  &:hover {
    background: white;
  }
  @media (max-width: 669px) {
    height: 4rem;
  }
`;

export const Text10 = () => css`
  font-family: Inter, Arial, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 20px;
  letter-spacing: -0.01em;
`;

export const TextLabel12 = () => css`
  color: ${colors.labelColor};
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.6rem;
  opacity: 0.5;
  letter-spacing: 0.4px;
`;

export const TextTable12 = () => css`
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.6rem;
  opacity: 0.5;
  letter-spacing: 0.4px;
`;

export const TextInfo14 = () => css`
  font-size: 1.4rem;
  line-height: 2rem;
  letter-spacing: 0.4px;
`;

export const TextInfo12 = () => css`
  font-family: Inter, Arial, sans-serif;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.4px;
`;

export const TextColor = () => css<{ color: string }>`
  color: ${props => `${colors[props.color as keyof IColors]}`};
`;

export const CardTitle = () => css`
  font-family: Gilroy, Arial, sans-serif;
  font-size: 1.8rem;
  line-height: 3.2rem;
`;

export const Text16 = () => css`
  font-family: Gilroy, Arial, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
`;

export const Text18Medium = () => css`
  font-family: Gilroy, Arial, sans-serif;
  font-size: 17px;
  font-weight: 500;
  line-height: 25px;
`;

export const FlexCenter = () => css`
  display: flex;
  align-items: center;
  text-align: center;
`;

export const InputArea = () => css`
  border: 0.2rem solid rgba(52, 70, 87, 1);
  border-radius: 0.4rem;
  height: 4rem;
`;

export const Text14Medium = () => css`
  font-family: Inter, Arial, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.4px;
`;

export const Text24Medium = () => css`
  font-family: Gilroy, Arial, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
`;

export const Text32Medium = () => css`
  font-family: Gilroy, Arial, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 45px;
`;

export const Text48Medium = () => css`
  font-family: Gilroy, Arial, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 48px;
  line-height: 58px;
  letter-spacing: -0.01em;
`;

export const Text64Medium = () => css`
  font-family: Gilroy, Arial, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 64px;
  line-height: 51.2px;
  letter-spacing: -0.01em;
`; 